import * as React from 'react';
import { Avatar, Button, Card, IconButton } from 'react-native-paper';
import defaultStyles from "./Styles"
import { connect } from 'react-redux';
import { deleteOlympiad } from '../store/actions/adminActions';
import { getOlympiads } from "../store/actions/userActions"
import AlertDialog from './AlertDialog';

export const OlympicsCard = ({ olympiad, navigation, token, deleteOlympiad, action, setAction }) => {
    const role = token?.split(" ")[0]
    const [visible, setVisible] = React.useState(false);
    const showModal = () => setVisible(true);
    const hideModal = () => setVisible(false);

    const handleDelete = () => {
        deleteOlympiad({ olympiadId: olympiad._id })
        hideModal()
        setAction(!action)
    }

    return (
        <>
            <AlertDialog visible={visible} handleAccept={handleDelete} handleClose={hideModal} message={`Are you sure you want to delete ${olympiad.name}?`} okText={"CONFIRM"} />
            <Card style={defaultStyles.card} onPress={() => { navigation.navigate("Olympiad", { olympiadId: olympiad._id }) }}>
                <Card.Title
                    title={olympiad.name}
                    subtitle={olympiad.description}
                    left={(props) => <Avatar.Icon {...props} icon="torch" />}
                />
                {role && role === "Super" &&
                    <Card.Actions>
                        <Button onPress={showModal} icon="delete">Delete</Button>
                    </Card.Actions>
                }
            </Card>
        </>
    )
}

const mapStateToProps = (state) => ({
    token: state?.auth?.token
});

const mapDispatchToProps = {
    deleteOlympiad,
    getOlympiads
};

export default connect(mapStateToProps, mapDispatchToProps)(OlympicsCard);